



































































import { MatchGameState } from '@/api/match'
import { BracketMatchGameEntity } from '@/api/stage'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class BracketMatchGameChips extends Vue {
  @Prop({ type: Object })
  readonly matchGame!: BracketMatchGameEntity

  @Prop({ type: Boolean, default: false }) readonly isCompleted!: boolean
  @Prop({ type: Boolean, default: false }) readonly outlined!: boolean
  @Prop({ type: Boolean, default: false }) readonly hideCheckInStatus!: boolean

  get state() {
    if (this.isCompleted) return MatchGameState.Completed

    if (!this.matchGame) return MatchGameState.Initial

    return this.matchGame.state
  }

  get isGameWaiting() {
    return this.state === 'Waiting'
  }

  get isGameCompleted() {
    return this.isCompleted || this.state === 'Completed'
  }

  get isGamePlaying() {
    return this.state === 'Playing'
  }

  get isGameRequiresAttention() {
    return this.state === 'ResultSubmitted' || this.state === 'Disputed'
  }

  get stateIcon() {
    switch (this.state) {
      case MatchGameState.Initial:
        return 'mdi-clock-outline'
      case MatchGameState.Waiting:
        return 'mdi-timer-sand'
      case MatchGameState.Playing:
        return 'mdi-play-outline'
      case MatchGameState.Completed:
        return 'mdi-check-bold'
      case MatchGameState.Ready:
        return 'mdi-check-all'
      case MatchGameState.ResultSubmitted:
      case MatchGameState.Disputed:
        return 'mdi-calendar-check-outline'
      default:
        return 'mdi-alert-octagon'
    }
  }
}
